import { BaseEntity, Company } from '@macs-frontend/features/shared';

export enum LeaveHolidayTypeStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface LeaveHolidayType extends BaseEntity {
  title: string;
  status: LeaveHolidayTypeStatus;
  occupationType: OccupationType;
  description?: string;
  yearlyLimit: number;
  company?: Company;
  isBillable: boolean;
}

export enum OccupationTypeStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface OccupationType extends BaseEntity {
  name: string;
  description?: string;
  status: OccupationTypeStatus;
  company?: Company;
}
